import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FullArrowLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M5 5v-.5h-.5V5zm6.646 7.354a.5.5 0 0 0 .708-.708zM5.5 9V5h-1v4zM5 5.5h4v-1H5zm-.354-.146 7 7 .708-.708-7-7z" }),
            React.createElement("path", { fill: "currentColor", d: "M5 19v.5h-.5V19zm6.646-7.354a.5.5 0 0 1 .708.708zM5.5 15v4h-1v-4zM5 18.5h4v1H5zm-.354.146 7-7 .708.708-7 7z" }),
            React.createElement("path", { fill: "currentColor", d: "M19 5v-.5h.5V5zm-6.646 7.354a.5.5 0 0 1-.708-.708zM18.5 9V5h1v4zm.5-3.5h-4v-1h4zm.354-.146-7 7-.708-.708 7-7z" }),
            React.createElement("path", { fill: "currentColor", d: "M19 19v.5h.5V19zm-6.646-7.354a.5.5 0 0 0-.708.708zM18.5 15v4h1v-4zm.5 3.5h-4v1h4zm.354.146-7-7-.708.708 7 7z" })));
}
const FullArrowLight = forwardRef(_FullArrowLight);
export { FullArrowLight };
